import { render, staticRenderFns } from "./createAlipayDia.vue?vue&type=template&id=22ee5774&scoped=true&"
import script from "./createAlipayDia.vue?vue&type=script&lang=js&"
export * from "./createAlipayDia.vue?vue&type=script&lang=js&"
import style0 from "./createAlipayDia.vue?vue&type=style&index=0&id=22ee5774&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22ee5774",
  null
  
)

export default component.exports